import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../../Button/Button'
import { useDeleteSavedAddress } from '../../../use-saved-addresses/use-saved-addresses'

export const DeleteSavedAddress = ({ savedAddress, onError, onCompleted }) => {
  const { guid: addressGuid } = savedAddress
  const [ deleteSavedAddress, { loading } ] = useDeleteSavedAddress({
    addressGuid,
    onError,
    onCompleted
  })

  return (
    <Button
      style='linkWide'
      type='button'
      loading={loading}
      onClick={deleteSavedAddress}
    >
      Delete
    </Button>
  )
}

DeleteSavedAddress.propTypes = {
  savedAddress: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  onCompleted: PropTypes.func.isRequired
}
